import React from 'react';
import { Tooltip, Form, List, Card, Tabs, Menu, Select, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled from 'styled-components';
import ToolbarContext from './ToolbarContext';

const ToolList = styled.div`
  background: rgb(4, 31, 55);
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;

class Index extends React.Component {
  state = {
    contextValue: {
      onClose: null,
    },
  };

  static getDerivedStateFromProps(props, state) {
    if (props.onClose !== state.contextValue.onClose) {
      return {
        ...state,
        contextValue: {
          onClose: props.onClose,
        },
      };
    }
    return null;
  }

  render() {
    const { logo, menu, children, onClose } = this.props;
    const { contextValue } = this.state;

    return (
      <React.Fragment>
        {!children && (
          <Layout.Sider style={{ background: '#1a2b3a' }} theme="dark" collapsed>
            <ToolList>
              <div>
                {logo}
              </div>
              <div>
                {menu}
              </div>
            </ToolList>
          </Layout.Sider>
        )}
        {children && (
          <Layout.Sider
            className="vb-theme--toolbox"
            width={400}
            theme="dark"
            style={{
              background: '#1a2b3a',
              position: 'relative',
              zIndex: '2',
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            <ToolbarContext.Provider value={contextValue}>
              {children}
            </ToolbarContext.Provider>
          </Layout.Sider>
        )}
      </React.Fragment>
    );
  }
}

export default Index;
